// The roadmap listens on the whole window for Space (play the selected level) and the
// left and right arrows (move between levels). A key belongs to those shortcuts only when
// nothing focused takes it: a focused button, link or field does its own action with the
// key, and nothing more.

// Elements that act on Space or Enter themselves: they press, follow, type or toggle.
const KEY_TAKING_ELEMENTS = [
  'a[href]',
  'button',
  'input',
  'select',
  'textarea',
  'summary',
  '[contenteditable]:not([contenteditable="false"])',
  '[role="button"]',
  '[role="link"]',
  '[role="checkbox"]',
  '[role="radio"]',
  '[role="switch"]',
  '[role="tab"]',
  '[role="menuitem"]',
  '[role="option"]',
  '[role="slider"]',
  '[role="spinbutton"]',
  '[role="combobox"]',
  '[role="textbox"]',
  '[role="listbox"]',
  '[role="dialog"]',
].join(', ');

// Elements where the left and right arrows already mean something: moving the caret,
// changing a value, or moving through options. (A button has no use for them, so the
// arrows still move between levels while a level is focused.)
const ARROW_TAKING_ELEMENTS = [
  'input',
  'select',
  'textarea',
  '[contenteditable]:not([contenteditable="false"])',
  '[role="slider"]',
  '[role="spinbutton"]',
  '[role="combobox"]',
  '[role="textbox"]',
  '[role="listbox"]',
  '[role="menu"]',
  '[role="menubar"]',
  '[role="radiogroup"]',
  '[role="tablist"]',
  '[role="dialog"]',
].join(', ');

const isTakenBy = (event: KeyboardEvent, takingElements: string): boolean =>
  event.defaultPrevented ||
  (event.target instanceof Element && event.target.closest(takingElements) !== null);

// Space with nothing focused (or focus on plain page content) plays the selected level.
export const isSpaceForThePage = (event: KeyboardEvent): boolean =>
  event.code === 'Space' && !isTakenBy(event, KEY_TAKING_ELEMENTS);

// The left and right arrows move between levels unless a focused control uses them.
export const isArrowForThePage = (event: KeyboardEvent): boolean =>
  (event.key === 'ArrowLeft' || event.key === 'ArrowRight') &&
  !isTakenBy(event, ARROW_TAKING_ELEMENTS);
